import {
  Button,
  cn,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@bleu.builders/ui";
import { CheckCircledIcon } from "@radix-ui/react-icons";
import { DownloadCloudIcon } from "lucide-react";
import React, { useState } from "react";

import { DownloadNowButton } from "./DownloadThesisButton";
import { DownloadUpdatedThesisModal } from "./DownloadUpdatedThesisModal";

export const DownloadThesisKit = ({ thesis, buttonClassName = {} }) => {
  const { id, organization_purchased, has_update, title } = thesis;

  const [isOpen, setIsOpen] = useState(false);

  const items = [
    "Minuta da petição inicial",
    "Manual da tese",
    "Contrato de honorários",
    "Procuração",
  ];

  // case the org already purchased and there is no update:
  // download without pop modal to confirm
  if (organization_purchased && !has_update) {
    return (
      <DownloadNowButton
        className={buttonClassName}
        thesisId={id}
        thesisTitle={title}
        setIsOpen={setIsOpen}
      />
    );
  }

  // case the org already purchased and there is an update:
  // open modal to select between download the updated version or not
  if (organization_purchased && has_update) {
    return (
      <DownloadUpdatedThesisModal
        thesisId={id}
        thesisTitle={title}
        optToDownloadOldKit={true}
      >
        <Button
          className={cn(
            "gap-2 bg-orange-500 hover:bg-orange-400",
            buttonClassName,
          )}
        >
          <DownloadCloudIcon />
          Baixar kit da tese
        </Button>
      </DownloadUpdatedThesisModal>
    );
  }

  // default case: open modal to confirm the download
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          className={cn(
            "gap-2 bg-orange-500 hover:bg-orange-400",
            buttonClassName,
          )}
        >
          <DownloadCloudIcon />
          Baixar kit da tese
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader className="justify-center">
          <DialogTitle className="flex gap-2 items-center justify-start text-center">
            <span className="text-primary">Baixar Kit da Tese</span>
            <DownloadCloudIcon className="text-primary size-5 font-bold" />
          </DialogTitle>
        </DialogHeader>
        <ul className="space-y-3">
          {items.map((item) => (
            <li key={item} className="flex items-center">
              <CheckCircledIcon className="text-green-700 size-4" />
              <span className="ml-1">{item}</span>
            </li>
          ))}
        </ul>
        <DialogFooter>
          <div className="w-full text-center">
            <DownloadNowButton
              className={buttonClassName}
              thesisId={id}
              thesisTitle={title}
              setIsOpen={setIsOpen}
            />
            <p className="mt-2 text-muted-foreground text-sm text-center italic">
              Um crédito será debitado do seu plano de assinatura.
            </p>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
